/**
 * Generated by orval v6.12.1 🍺
 * Do not edit manually.
 * Platz API
 * Platz API boi
 * OpenAPI spec version: 2.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  UseMutationOptions,
  MutationFunction,
} from "@tanstack/react-query";
import type { PlatzApiError, LoginParams } from ".././model";
import { customInstance } from "../../../axios";
import type { ErrorType } from "../../../axios";

export const login = (params: LoginParams) => {
  return customInstance<string>({
    url: `/api/auth/login`,
    method: "post",
    params,
  });
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;

export type LoginMutationError = ErrorType<PlatzApiError>;

export const useLogin = <
  TError = ErrorType<PlatzApiError>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { params: LoginParams },
    TContext
  >;
}) => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { params: LoginParams }
  > = (props) => {
    const { params } = props ?? {};

    return login(params);
  };

  return useMutation<
    Awaited<ReturnType<typeof login>>,
    TError,
    { params: LoginParams },
    TContext
  >(mutationFn, mutationOptions);
};
